<template >
  <article class="accessIndex" v-if="loaded">
    <div class="accessIndex__general_info">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg10 class="head_contain">
          <p class="table_card__head--title">
            Alertas múltiples dispositivos
          </p>
          <span>Aquí se muestran los usuarios que han accedido con distintos dispositivos, el tipo, y el acumulativo de cuantos dispositivos distintos ha accedido el usuario</span>
        </v-flex>
        <v-flex xs12 lg2 class="filter_options">
          <div
            class="buttom_reload"
            style="float: right"
            @click="pagination_query=false;filterInvitations(true);date_available=false;"
          >
            <img src="@/assets/img/icons/refresh-icon.svg">
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="accessIndex__access_items--date_container_generic">
      <app-date-picker v-if="date_available"
        @filterQuery="pagination_query=false;filterInvitations(false,$event)"></app-date-picker>
    </div>
    <section>
      <v-data-table
        :headers="headers"
        :items="invitations"
        :pagination.sync="sorter"
        hide-actions
        class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ dateFormat($moment(props.item.alert_date).format(" MM/DD/YYYY")) }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.document_number }}</td>
          <td>{{ dateFormat($moment(props.item.first_access).format(" MM/DD/YYYY - h:mm a")) }}</td>
          <td>{{ dateFormat($moment(props.item.last_access).format(" MM/DD/YYYY - h:mm a")) }}</td>
          <td>{{ props.item.quantity_accesses }}</td>
          <td>{{ props.item.device_types.join() }}</td>
        </template>
      </v-data-table>
    </section>
    <div v-if="invitations.length>0&& pages > 1" class="accessIndex__pagination">
      <v-pagination  color="light-blue darken-3" v-model="pagination.page" :length="pages"></v-pagination>
      <label class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
      <label class="accessIndex__pagination--current_text" v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}</label>
      <label class="accessIndex__pagination--current_text" v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>

    </div>

  </article>
</template>

<script>
export default {
  data(){
    return{
      sorter: {sortBy: 'first_access', descending: true, rowsPerPage: -1},
      saved_default_option:false,
      pagination_query:false,
      date_available:false,
      invitations_size:0,
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2:false,
      datePickerFirstClick:false,
      pages:2,
      pagination: {page:1,rowsPerPage:24},
      invitations: [],
      loaded: false,
      newemail:'',
      headers: [
        {text:'Fecha', value: 'alert_date'},
        {text:'Usuario', value: 'name'},
        {text:'Documento', value: 'document_number'},
        {text:'Fecha y hora penúltimo dispositivo', value: 'first_access'},
        {text:'Fecha y hora último dispositivo', value: 'last_access'},
        {text:'Dispositivos diferentes', value: 'quantity_accesses'},
        {text:'Tipos de dispositivos', value: 'device_types'},
      ],
      months:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre	","Octubre","	Noviembre","Diciembre"]

    }
  },
  watch: {
     'pagination.page': function (val, oldVal) {
       if(oldVal!=val&&val!=null&&oldVal!=null&&val==1&&!this.pagination_query){

       }
       else if(oldVal!=val&&val!=null&&oldVal!=null){
         this.pagination_query=true;
         this.filterInvitations(false);

       }

       }
    },
  methods:{
    modifyDateFormatToStatus(datex){
      var entries=datex.split('/');
      entries=[entries[2],entries[0],entries[1]];
      return entries.join("-");
    },
    dateFormat(datex){
        var sections=datex.split("/");
        var index=Number(sections[0])-1;
        sections[0]=this.months[index];
        datex=sections.join(" ");
        return datex;
    },
    monthEarlier(){
      var datex=new Date();
      datex.setMonth(datex.getMonth() - 1);
      return datex.toISOString().substr(0, 10);
    },
    filterInvitations(defaultOption,dates){
      if(this.pagination_query){
        defaultOption=this.saved_default_option;
      }
      else{
        this.pagination.page=1;
      }
      this.saved_default_option=defaultOption;
      var initialDate=this.monthEarlier();
      var lastDate=new Date().toISOString().substr(0, 10);
      if(!defaultOption){
        var object = dates != undefined && dates != null ? dates : {date_from: '', date_to: '' };
          if(object.date_from!='Desde'&&object.date_to!='Hasta'&&object.date_from!=''){
            this.datePickerFirstClick=true;
            this.date = this.modifyDateFormatToStatus(object.date_from);
            this.date2 = this.modifyDateFormatToStatus(object.date_to);
          }
          initialDate=this.date;
          lastDate=this.date2;
      }
      else{
        this.date= this.monthEarlier();
        this.date2= new Date().toISOString().substr(0, 10);
        this.datePickerFirstClick=false;
      }
      try {
        this.$http.get('access/get_alerts',{
          params:{
            type: 'DIFFERENT_DEVICE',
            offset_time: new Date().getTimezoneOffset(),
            first_date: initialDate,
            last_date: lastDate,
            page:this.pagination.page,
            company: this.getCompany().id
          },
          headers:
            {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }
          }
        ).then(function(response){
          this.invitations= [];
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          var temp=response.body.data;

          for (var i=0;i<temp.length;i++) {


            this.invitations.push({
              alert_date: temp[i].alert_date,
              document_number: temp[i].rut,
              name:temp[i].user_name,
              first_access:temp[i].last_devices[0],
              last_access:temp[i].last_devices[1],
              quantity_accesses:temp[i].quantity_devices,
              device_types: temp[i].device_types
            })
          }
          this.invitations_size=response.body.total_elements;
          this.pages=response.body.pages;
          console.table(response.body.data)
          this.loaded = true;
          this.date_available=true;
        }, function(response){
          if (response.body.data.message != null &&
              response.body.data.message != undefined &&
              response.body.data.message != '' ){
              alert(response.body.data.message)
          }else{
            alert(response.body.data)
          }
        })
      } catch (e) {
        alert(e.message)
      }
    }

  },
  mounted(){
    this.date= this.monthEarlier();
    // this.pagination.rowsPerPage=12;
    this.filterInvitations(true);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/access/Alerts_device.vue